export default __webpack_public_path__ + "static/media/banner1.ca3221cd.png";